import moment from "moment";
import { Button } from "risa-oasis-ui_v2";

interface MedicationListFooterProps {
  lastSync: string;
  dirtyCount: number;
  saving: boolean;
  onSave: () => void;
}

const MedicationListFooter = ({
  lastSync,
  dirtyCount,
  saving,
  onSave,
}: MedicationListFooterProps) => {
  return (
    <div className="flex flex-shrink-0 items-center justify-between gap-4 border-t border-primaryGray-16 pt-3">
      <div className="flex flex-col text-tiny text-primaryGray-7 sm:flex-row sm:items-center sm:gap-4">
        {lastSync && (
          <div>
            Updated at:{" "}
            <span className="font-semibold text-primaryGray-1">
              {moment(lastSync).format("DD MMM YYYY HH:mm")}
            </span>
          </div>
        )}
        {/* <div
          className={
            dirtyCount > 0 ? "font-semibold text-tertiaryBlue-4" : undefined
          }
        >
          {dirtyLabel}
        </div> */}
      </div>
      <div className="flex items-center gap-2">
        {/* <Button
          buttonType="secondary"
          size="medium"
          disabled={dirtyCount === 0 || saving}
          onClick={onDiscard}
        >
          Discard
        </Button> */}
        <Button
          buttonType="primary"
          size="medium"
          disabled={dirtyCount === 0 || saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Save Changes"}
        </Button>
      </div>
    </div>
  );
};

export default MedicationListFooter;
